<template>
  <div class="videos">
    <div class="videos__inner">
      <div class="videos__items">
        <div
          v-for="(item, i) in videos"
          :key="`item_${i}`"
          class="videos__item"
          data-animation="fadeInRight"
          :data-animation-delay="delay + (i * itemDelay)"
        >
          <BasePoster
            v-if="item.image"
            :name="item.image"
            class="videos__image"
            is-video
            @play="$emit('play', item.image)"
          />
          <div class="videos__description">
            <BaseTitle v-if="item.title" :text="item.title" size="m" is-medium class="videos__title" />
            <BaseText v-if="item.text" v-html="item.text" size="xs" class="videos__text" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePoster from '@/components/BasePoster.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';

export default {
  name: 'TheVideos',
  components: {
    BasePoster,
    BaseTitle,
    BaseText,
  },
  props: {
    videos: {
      type: Array,
      default: () => [],
    },
    itemDelay: {
      type: Number,
      default: 300,
    },
    delay: {
      type: Number,
      default: 0,
    },
  },
  // data() {
  //   return {
  //     name: '',
  //     email: '',
  //     message: '',
  //   };
  // },
  // staticData: () => ({
  //   menu: slides.filter((slide) => slide.addToMenu),
  // }),
  // computed: {
  //   isIntroPage() {
  //     return this.$route.path === paths.intro;
  //   },
  // },
  // methods: {
  //   checkClick(e) {
  //     if (e.target.closest('.header__nav')) return;
  //     this.hideMenu();
  //   },
  //   showMenu() {
  //     this.isMenuOpen = !this.isMenuOpen;
  //   },
  //   hideMenu() {
  //     this.isMenuOpen = false;
  //   },
  // },
};
</script>

<style lang="stylus">
.videos
  display block

  &__inner
    +portrait()
      overflow hidden

  &__items
    display flex
    +landscape()
      flex-wrap wrap
      justify-content space-between
    +portrait()
      overflow-x scroll
      padding-left 1.4em
      padding-bottom 1em
      margin-bottom -1em
      &:after
        content ''
        display block
        flex 0 0 1.4em

  &__item
    +portrait()
      flex 0 0 14em
      max-width 14em
      margin-left 1.4em
      &:first-child
        margin-left 0
    +landscape()
      flex 0 0 33.33333333%
      max-width calc(33.33333333% - 1em)
      margin 0
      &:not(:nth-child(-n+3))
        margin-top 3em

  &__image
    margin-bottom 1em

  &__title
    margin-bottom 0.15em

  &__text
    max-width 90%
</style>
